import React, { useEffect, useState } from 'react';
import { Descriptions, Badge, Layout, Row, Col, Card, Button, Spin, Input } from 'antd';
import './documents.css';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { ConditionsRequest, CrrencySymbols, SaleOrderDetailDto, SaleOrderDetailViewInfoDTO } from '@gtpl/shared-models/sale-management';
import { FactoriesInput, PlantInvoiceDetailsModel, PlantInvoiceDetailsRequest, UnitsOfWeightInput, } from '@gtpl/shared-models/sale-management';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { ExporterDataInput } from '@gtpl/shared-models/logistics';
import { GlobalStatus, UomEnum } from '@gtpl/shared-models/common-models';
import { useLocation } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons'
import { PrinterOutlined } from '@ant-design/icons'
let converter = require('number-to-words');
import { numberToWords } from 'amount-to-words'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import moment from 'moment';
import { ToWords } from 'to-words';
import stampImage from "./stamp.png";
import signature from "./signature.png"
import { GlobalPriceChartService } from 'libs/shared-services/masters/src/lib/global-price-chart.service';


// const { ToWords } = require('to-words');
const toWords = new ToWords({
  localeCode: 'en-US',
});
/* eslint-disable-next-line */
export interface ProformaInvoiceProps {
  saleOrderId: number;

}

export const getCssFromComponent = (fromDoc: Document, toDoc: Document) => {
  Array.from(fromDoc.styleSheets).forEach((styleSheet: CSSStyleSheet) => {
    try {
      if (styleSheet?.cssRules) { // true for inline styles and same-origin stylesheets
        const newStyleElement = toDoc.createElement("style");
        Array.from(styleSheet.cssRules).forEach((cssRule: CSSRule) => {
          newStyleElement.appendChild(toDoc.createTextNode(cssRule.cssText));
        });
        toDoc.head.appendChild(newStyleElement);
      }
    } catch (e) {
      console.warn("Could not access stylesheet rules for", styleSheet.href, e);
    }
  });
};

export function ProformaInvoice(props: ProformaInvoiceProps) {
  let location = useLocation();
  const salOrderService = new SaleOrderService();
  const [plantDetails, setPlantDetails] = useState<PlantInvoiceDetailsModel>();
  const soId = location.state;
  const [remarksData, setRemarksData] = useState<string>(undefined);
  const { TextArea } = Input;
  const defaultDeclaration = 'We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct'
  const [conditionRes, setConditionRes] = useState([]);

  console.log(location.state);
  let totalCases = 0;
  // let netWeightInKgs = 0;
  let totalAmount = 0;
  let itemsTotalAmount = 0;
  let totalLbWeight = 0;
  let totalGrossWeight = 0;
  let totalFrozenWeight = 0;
  let totalInvoiceAmount = 0;

  let FOBInRs = 0;
  let FOBInUSD = 0;
  let lbPouchWeight;
  let kgPouchWeight;

  let netWeightCalc;
  let totalAm = 0;

  let netWeightInKgs = 0;
  let netWeightInLbs = 0;
  let grossWeightInKg;
  let frozenWeightInKg;
  let cgst = 0;
  let sgst = 0;
  let igst = 0;
  let cgstPer = 0;
  let sgstPer = 0;
  let igstPer = 0;

  let declarationNote

  let totalAmnt = 0;
  let newUnitPrice;
  let newTotalAmount = 0;
  let antiDumping;
  let fob;
  const totalItems = plantDetails?.gradeInfo?.reduce((acc, g) => acc + g.info.length, 0) || 0;
  const minVisibleItemRows = 8;
  const spacerRowsNeeded = Math.max(0, minVisibleItemRows - totalItems);

  const renderItemSpacerRows = (keyPrefix: string) => (
    <>
      {Array.from({ length: spacerRowsNeeded }).map((_, idx) => (
        <tr key={`${keyPrefix}-spacer-${idx}`} className="items-row">
          <td colSpan={3} style={{ height: '18px' }}></td>
          <td colSpan={11} style={{ borderRight: '1px solid black', height: '18px' }}></td>
          <td colSpan={2} style={{ borderRight: '1px solid black', height: '18px' }}></td>
          <td colSpan={2} style={{ borderRight: '1px solid black', height: '18px' }}></td>
          <td colSpan={2} style={{ borderRight: '1px solid black', height: '18px' }}></td>
        </tr>
      ))}
    </>
  );


  const printOrder = () => {
    const divContents = document.getElementById('printme').innerHTML;
    const element = window.open('', '', 'height=700, width=1020');

    // Write content to the new window
    element.document.write(`
        <html>
        <body>
            ${divContents}
            <style>
                @page {
                    size: A4 portrait;
                    margin: 10mm;
                }
                #table-to-xls {
                    width: 100%;
                    min-height: 250mm;
                    max-height: 280mm;
                    line-height: 1.3;
                    font-weight: 500;
                    font-family: Calibri, sans-serif;
                    border-collapse: collapse;
                }
                body {
                    font-family: Calibri, sans-serif;
                    margin: 0;
                    padding: 0;
                }
                #table-to-xls tr td {
                    font-size: 13px;
                    font-weight: 500;
                    padding: 4px;
                }
                .title-row td {
                    font-size: 18px !important;
                }
                .label-text {
                    font-size: 12px !important;
                }
                .value-text {
                    font-size: 15px !important;
                }
                .items-row td {
                    font-size: 13px !important;
                    padding: 6px 4px !important;
                }
            </style>
        </body>
        </html>
    `);

    getCssFromComponent(document, element.document);
    element.document.close();

    setTimeout(() => {
      element.print();
      element.close();
    }, 1000);
  };

  const getData = (saleOrderId) => {
    salOrderService.getPlantInvoiceDetails(new PlantInvoiceDetailsRequest(saleOrderId)).then((res) => {
      console.log(res);
      if (res.status) {
        console.log(res.data.proformaInvoiceDate, 'ooooooooooooo');
        setPlantDetails(res.data);

      } else {
        if (res.intlCode) {
          setPlantDetails(undefined);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    })
      .catch((err) => {
        AlertMessages.getErrorMessage(err.message);
        setPlantDetails(undefined);
      });
  };


  useEffect(() => {
    if (props.saleOrderId) {
      getData(props.saleOrderId);
    }
  }, [props.saleOrderId])
  let exporterDetails = ExporterDataInput;

  const exporterIdOrUnitCodeId = plantDetails?.isInvoiced === GlobalStatus.YES
    ? plantDetails?.exporterId
    : plantDetails?.unitData?.unitcodeId;

  const exporterData = exporterDetails.find(
    (item) => item.value === exporterIdOrUnitCodeId
  );
  const processingId = plantDetails?.processingUnit;

  const processingData = exporterDetails.find(
    (item) => item.value === processingId
  );
  let exporterPlant = FactoriesInput;
  const exportersPlant = exporterPlant.find(
    (item) => item.id == plantDetails?.invoicedPlant?.unitcodeId
  )
  let unitInput = FactoriesInput;
  const unitsData = FactoriesInput.find(item => item.id == plantDetails?.unitId)


  let spanVal = 0
  let adjustSpan = 0
  const rowSpanValue = Math.round(plantDetails?.gradeInfo?.length / 2);
  if (plantDetails?.gradeInfo?.length % 2 !== 0 && plantDetails?.gradeInfo?.length > 1) {
    console.log('odd and > 1', Math.round(plantDetails?.gradeInfo?.length / 2));

    spanVal = Math.round(plantDetails?.gradeInfo?.length / 2)
    adjustSpan = Math.round(plantDetails?.gradeInfo?.length / 2) - 1
  }
  else if (plantDetails?.gradeInfo?.length === 1) {
    spanVal = 1
    console.log('equals to 1', Math.round(plantDetails?.gradeInfo?.length));

    adjustSpan = 1
  } else {
    spanVal = Math.round(plantDetails?.gradeInfo?.length / 2)
    adjustSpan = Math.round(plantDetails?.gradeInfo?.length / 2)
    console.log('even', Math.round(plantDetails?.gradeInfo?.length / 2));

  }

  const handleRemarks = (value) => {
    setRemarksData(value);
  }
  let hasNumber = /\d/;
  let normalOrder = hasNumber.test(plantDetails?.buyerPoNo);
  let lotRefString = '';
  let lotNo = '';
  let RefNo = '';
  if (normalOrder) {
    if (plantDetails?.lotCode) {
      lotNo = 'LOT NO. ' + plantDetails?.lotCode + ', '
    }
    if (plantDetails?.buyerPoNo) {
      RefNo = 'REF NO. ' + plantDetails?.buyerPoNo
    }
    lotRefString = lotNo + RefNo
  }
  {
    (() => {
      totalLbWeight = 0;
      totalInvoiceAmount = 0;
      return null;
    })()
  }

  {
    plantDetails?.gradeInfo?.map((g, gIndex) =>
      g.info.map((r, idx) => {

        const uom = UnitsOfWeightInput.find((u: any) => u.value == r.uomId);
        const uomPrice = UnitsOfWeightInput.find((u: any) => u.value == r.priceUom);

        let finalNetWeight: number;
        let unitPrice: number;

        // Calculation Logic
        if (conditionRes?.[0]?.quantityUom === true) {
          finalNetWeight = (uom?.name === UomEnum.LB || uom?.name === UomEnum.OZ)
            ? Number(r.quatity)
            : Number(r.quatity) / 0.454;

          unitPrice = (uomPrice?.name === UomEnum.LB || uomPrice?.name === UomEnum.OZ)
            ? Number(r.price)
            : Number(r.price) * 0.454;
        } else {
          finalNetWeight = (uom?.name === UomEnum.LB || uom?.name === UomEnum.OZ)
            ? Number(r.quatity) * 0.454
            : Number(r.quatity);

          unitPrice = (uomPrice?.name === UomEnum.LB || uomPrice?.name === UomEnum.OZ)
            ? Number(r.price) / 0.454
            : Number(r.price);
        }

        const rowAmount = Number(unitPrice) * Number(finalNetWeight);

        totalLbWeight += finalNetWeight;
        totalInvoiceAmount += rowAmount;

        return (
          <tr key={`${gIndex}-${idx}`}>
            <td className="ta-b" style={{ padding: '6px', textAlign: 'center' }}></td>
            <td className="ta-b" style={{ padding: '6px', fontWeight: 'bold' }}>
              {g?.productDescription?.toUpperCase()}
            </td>
            <td className="ta-b" style={{ textAlign: 'center', padding: '6px' }}>
              {Number(finalNetWeight).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </td>
            <td className="ta-b" style={{ textAlign: 'center', padding: '6px' }}>
              {Number(unitPrice).toFixed(2)}
            </td>
            <td className="ta-b" style={{ textAlign: 'center', padding: '6px', fontWeight: 'bold' }}>
              {rowAmount.toFixed(2)}
            </td>
          </tr>
        );
      })
    )
  }
  return (
    <Card
      // title="Proforma Invoice"
      // style={{ textAlign: "center" }}
      // headStyle={{ backgroundColor: "#69c0ff", border: 0 }}
      extra={
        <span style={{ color: "white" }}>
          <Button onClick={printOrder} className='noprint' style={{ float: 'right', backgroundColor: '#69c0ff' }}><span style={{ color: 'white' }}><PrinterOutlined /> Print</span></Button>
        </span>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', overflowX: 'auto', }}>

        {plantDetails ?
          <html>

            <head></head>
            <br />
            <body id='printme' className={"stylesInfo"} style={{ width: '100%', maxWidth: '210mm', backgroundColor: 'white',  boxShadow: '0 0 10px rgba(0,0,0,0.1)', margin: 'auto' }}>


              <br></br>


              <table
                style={{
                  width: '100%',
                  minHeight: '250mm',
                  maxHeight: '280mm',
                  borderCollapse: 'collapse',
                  border: '1px solid black',
                  fontSize: '13px',
                  lineHeight: '1.4',
                  fontFamily: 'Calibri, sans-serif'
                }}
                id="table-to-xls"
              >

                <tr>
                  <td colSpan={20} style={{ textAlign: 'center', padding: '10px', fontSize: '18px', fontWeight: 'bold', borderBottom: '1px solid black' }}>
                    PROFORMA INVOICE
                  </td>
                </tr>

                <tr>
                  <td colSpan={8} rowSpan={2} style={{
                    verticalAlign: 'top',
                    padding: '6px',
                    borderRight: '1px solid black',
                    borderBottom: '1px solid black',
                    width: '40%'
                  }}>
                    <span style={{ fontSize: '12px' }}>Exporter:</span><br />
                    <b style={{ fontSize: '16px' }}>{exporterData?.company} ,</b><br />
                    <span style={{ fontSize: '13px' }}>
                      {exporterData?.addressOne},<br />
                      {exporterData?.addressTwo},<br />
                      {exporterData?.state}<br />
                      {exporterData?.country}
                    </span>
                  </td>

                  <td colSpan={6} style={{ borderRight: '1px solid black', borderBottom: '1px solid black', padding: '8px', textAlign: 'center', width: '30%' }}>
                    <span style={{ fontSize: '12px', fontWeight: 'bold' }}>INVOICE NO.</span><br />
                    <b style={{ fontSize: '15px' }}>{plantDetails?.proformaInv}</b>
                  </td>

                  <td colSpan={6} style={{ borderBottom: '1px solid black', padding: '8px', textAlign: 'center', width: '30%' }}>
                    <span style={{ fontSize: '12px', fontWeight: 'bold' }}>DATE</span><br />
                    <b style={{ fontSize: '15px' }}>{moment(plantDetails?.proformaInvoiceDate).format('DD-MM-YYYY')}</b>
                  </td>
                </tr>

                <tr>
                  <td colSpan={12} style={{  borderBottom: '1px solid black', padding: '8px', verticalAlign: 'left' }}>
                    <b style={{ fontSize: '13px' }}>I.E C. {exporterData?.ieCode}.</b>
                  <br />
                    <b style={{ fontSize: '13px' }}>GSTIN : {exporterData?.GSTNumber}</b>
                  </td>
                </tr>

                <tr>
                  <td colSpan={8} style={{ borderRight: '1px solid black', borderBottom: '1px solid black', padding: '8px', verticalAlign: 'top', height: '120px' }}>
                    <span style={{ fontSize: '12px' }}>Consignee:</span><br />
                    <b style={{ fontSize: '15px' }}>{plantDetails?.consignee}</b><br />
                    <span style={{ fontSize: '13px' }}>{plantDetails?.country}</span>
                  </td>
                  <td colSpan={12} style={{ borderBottom: '1px solid black', padding: '8px', verticalAlign: 'top' }}>
                    <b style={{ fontSize: '12px' }}>BANK DETAILS:</b><br />
                    <span style={{ fontSize: '13px' }}>
                      {plantDetails?.bankInfo?.[0]?.displayName}<br />
                      Bank name: {plantDetails?.bankInfo?.[0]?.bankName}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td colSpan={4} style={{ borderRight: '1px solid black', textAlign: 'center', padding: '5px', fontWeight: 'bold', fontSize: '10px', width: '20%' }}>PORT OF LOADING</td>

                  <td colSpan={4} style={{ borderRight: '1px solid black', textAlign: 'center', padding: '5px', fontWeight: 'bold', fontSize: '10px', width: '20%' }}>FINAL DESTINATION</td>
                  <td colSpan={6} style={{ borderRight: '1px solid black', textAlign: 'center', padding: '5px', fontWeight: 'bold', fontSize: '10px', width: '30%' }}>COUNTRY OF ORIGIN OF GOODS</td>
                  <td colSpan={6} style={{ textAlign: 'center', padding: '5px', fontWeight: 'bold', fontSize: '10px', width: '30%' }}>DESTINATION COUNTRY</td>
                </tr>

                <tr>
                  <td colSpan={4} style={{ borderRight: '1px solid black', borderBottom: '1px solid black', textAlign: 'center', padding: '5px', fontWeight: 'bold' }}>
                    {plantDetails?.portofloading}
                  </td>
                  <td colSpan={4} style={{ borderRight: '1px solid black', borderBottom: '1px solid black', textAlign: 'center', padding: '5px', fontWeight: 'bold' }}>
                    {plantDetails?.saleOrderItems?.[0]?.destinationDetails}
                  </td>
                  <td colSpan={6} style={{ borderRight: '1px solid black', borderBottom: '1px solid black', textAlign: 'center', padding: '5px', fontWeight: 'bold' }}>INDIA</td>
                  <td colSpan={6} style={{ borderBottom: '1px solid black', textAlign: 'center', padding: '5px', fontWeight: 'bold' }}>
                    {plantDetails?.saleOrderItems?.[0]?.destinationDetails}
                  </td>
                </tr>

                <tr>
                  <td colSpan={3} style={{ borderBottom: '1px solid black', textAlign: 'center', padding: '6px', fontWeight: 'bold', fontSize: '11px', width: '15%' }}>MARKS</td>
                  <td colSpan={11} style={{ borderRight: '1px solid black', borderBottom: '1px solid black', textAlign: 'center', padding: '6px', fontWeight: 'bold', fontSize: '11px', width: '55%' }}>DESCRIPTION</td>
                  <td colSpan={2} style={{ borderRight: '1px solid black', borderBottom: '1px solid black', textAlign: 'center', padding: '6px', fontWeight: 'bold', fontSize: '11px' }}>Quantity</td>
                  <td colSpan={2} style={{ borderRight: '1px solid black', borderBottom: '1px solid black', textAlign: 'center', padding: '6px', fontWeight: 'bold', fontSize: '11px' }}>Rate</td>
                  <td colSpan={2} style={{ borderBottom: '1px solid black', textAlign: 'center', padding: '6px', fontWeight: 'bold', fontSize: '11px' }}>Amount</td>
                </tr>

                {(() => { totalLbWeight = 0; totalInvoiceAmount = 0; return null; })()}

                {plantDetails?.gradeInfo?.map((g, gIndex) =>
                  g.info.map((r, idx) => {
                    const uom = UnitsOfWeightInput.find((u: any) => u.value == r.uomId);
                    const uomPrice = UnitsOfWeightInput.find((u: any) => u.value == r.priceUom);

                    let finalNetWeight = 0;
                    let unitPrice = 0;

                    if (conditionRes?.[0]?.quantityUom === true) {
                      finalNetWeight = (uom?.name === UomEnum.LB || uom?.name === UomEnum.OZ)
                        ? Number(r.quatity) : Number(r.quatity) / 0.454;
                      unitPrice = (uomPrice?.name === UomEnum.LB || uomPrice?.name === UomEnum.OZ)
                        ? Number(r.price) : Number(r.price) * 0.454;
                    } else {
                      finalNetWeight = (uom?.name === UomEnum.LB || uom?.name === UomEnum.OZ)
                        ? Number(r.quatity) * 0.454 : Number(r.quatity);
                      unitPrice = (uomPrice?.name === UomEnum.LB || uomPrice?.name === UomEnum.OZ)
                        ? Number(r.price) / 0.454 : Number(r.price);
                    }

                    const rowAmount = Number(unitPrice) * Number(finalNetWeight);

                    totalLbWeight += finalNetWeight;
                    totalInvoiceAmount += rowAmount;

                    return (
                      <tr key={`${gIndex}-${idx}`} className="items-row">
                        <td colSpan={3} style={{ padding: '6px', textAlign: 'center' }}></td>
                        <td colSpan={11} style={{ padding: '6px', textAlign: 'center', borderRight: '1px solid black' }}>
                          <b style={{ fontSize: '13px' }}>{g?.productDescription?.toUpperCase()}</b><br />
                        </td>
                        <td colSpan={2} style={{ padding: '6px', textAlign: 'center', borderRight: '1px solid black' }}>
                          <b style={{ fontSize: '13px' }}>{Number(finalNetWeight).toLocaleString('en-US', { minimumFractionDigits: 1 })}</b>
                        </td>
                        <td colSpan={2} style={{ padding: '6px', textAlign: 'center', borderRight: '1px solid black' }}>
                          <b style={{ fontSize: '13px' }}>{Number(unitPrice).toFixed(2)}</b>
                        </td>
                        <td colSpan={2} style={{ padding: '6px', textAlign: 'center', borderRight: '1px solid black' }}>
                          <b style={{ fontSize: '13px' }}>{rowAmount.toFixed(2)}</b>
                        </td>
                      </tr>
                    );
                  })
                )}

                {renderItemSpacerRows('invoice')}

                <tr>
                  <td colSpan={14} style={{ borderTop: '1px solid black', padding: '8px' }}>
                    <b style={{ fontSize: '12px' }}>Amount Chargeable: &nbsp;&nbsp; {toWords.convert(Number(totalInvoiceAmount), { currency: true }).toUpperCase()}.</b><br />
                    <span style={{ fontSize: '10px' }}>(In Words)</span>
                  </td>
                  <td colSpan={4} style={{ borderTop: '1px solid black', textAlign: 'right', padding: '8px', fontWeight: 'bold', fontSize: '13px' }}>
                    TOTAL
                  </td>
                  <td colSpan={2} style={{ borderTop: '1px solid black',borderLeft: '1px solid black',borderBottom: '1px solid black', textAlign: 'right', padding: '3px 8px', fontWeight: 'bold', fontSize: '13px' }}>
                    {Number(totalInvoiceAmount).toFixed(2)}
                  </td>
                </tr>

                <tr>
                  <td colSpan={20} style={{  padding: '8px', verticalAlign: 'top' }}>
                    <b style={{ fontSize: '12px' }}>TERMS AND CONDITIONS:</b><br />
                    <b style={{ fontSize: '11px' }}>PAYMENT TERMS: {plantDetails?.saleOrderItems?.[0]?.paymentTerms?.toUpperCase()}</b><br />
                    <b style={{ fontSize: '11px' }}>SHIPMENT: 1) DISPATCH BY {moment(plantDetails?.proformaInvoiceDate).add(15, 'days').format('DD MMMM YYYY')?.toUpperCase()}</b><br />
                    <b style={{ fontSize: '11px' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2) CIF TO {plantDetails?.saleOrderItems?.[0]?.destinationDetails?.toUpperCase()}</b><br />
                    <b style={{ fontSize: '11px' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3) COUNTRY OF ORIGIN - INDIA</b><br />
                    <b style={{ fontSize: '11px' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4) MODE OF SHIPMENT - BY SEA</b><br />
                    <b style={{ fontSize: '11px' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5) QUANTITY 10% +/-</b>
                  </td>
                </tr>

                <tr>
                  <td colSpan={12} style={{ padding: '8px', verticalAlign: 'bottom' }}>
                    <u><b style={{ fontSize: '12px' }}>Declaration:</b></u><br />
                    <span style={{ fontSize: '10px', fontWeight:500, width: '80%' }}>
                      WE DECLARE THAT THIS INVOICE SHOWS THE ACTUAL PRICE OF THE GOODS
                      DESCRIBED AND THAT ALL THE PARTICULARS ARE TRUE AND CORRECT.
                    </span>
                  </td>
                  <td colSpan={2}></td>
                  <td colSpan={6} style={{ borderLeft: '1px solid black', borderTop: '1px solid black', textAlign: 'center', padding: '8px', verticalAlign: 'top' }}>
                    <b style={{ fontSize: '12px' }}>For S.P.S.A.SILKS PVT. LTD.,</b>
                    <br /><br /><br /><br />
                    <span style={{ fontSize: '11px' }}>Authorised signatory</span>
                  </td>
                </tr>
              </table>

              {/* PAGE BREAK */}
              <div style={{ pageBreakBefore: 'always' }}></div>
              <br></br>
              <br></br>

              <table
                style={{
                  width: '100%',
                  minHeight: '250mm',
                  maxHeight: '280mm',
                  borderCollapse: 'collapse',
                  border: '1px solid black',
                  fontSize: '13px',
                  lineHeight: '1.4',
                  marginTop: '20px',
                  fontFamily: 'Calibri, sans-serif'
                }}
              >

                <tr>
                  <td colSpan={20} style={{ textAlign: 'center', padding: '10px', fontSize: '18px', fontWeight: 'bold', borderBottom: '1px solid black' }}>
                    ORDER CONFIRMATION
                  </td>
                </tr>

                <tr>
                  <td colSpan={8} rowSpan={2} style={{
                    verticalAlign: 'top',
                    padding: '8px',
                    borderRight: '1px solid black',
                    borderBottom: '1px solid black',
                    width: '40%'
                  }}>
                    <span style={{ fontSize: '12px' }}>Exporter:</span><br />
                    <b style={{ fontSize: '16px' }}>{exporterData?.company} ,</b><br />
                    <span style={{ fontSize: '13px' }}>
                      {exporterData?.addressOne},<br />
                      {exporterData?.addressTwo},<br />
                      {exporterData?.state}<br />
                      {exporterData?.country}
                    </span>
                  </td>

                  

                  <td colSpan={6} style={{ borderBottom: '1px solid black',borderRight:'1px solid black', padding: '8px', textAlign: 'center', width: '30%' }}>
                    <span style={{ fontSize: '12px', fontWeight: 'bold' }}>DATE</span><br />
                    <b style={{ fontSize: '15px' }}>{moment(plantDetails?.proformaInvoiceDate).format('DD-MM-YYYY')}</b>
                  </td>
                  <td colSpan={6} style={{ borderRight: '1px solid black', borderBottom: '1px solid black', padding: '8px', textAlign: 'center', width: '30%' }}>
                    <span style={{ fontSize: '12px', fontWeight: 'bold' }}>SALES CONTRACT</span><br />
                    <b style={{ fontSize: '15px' }}>{plantDetails?.proformaInv}</b>
                  </td>
                </tr>

                <tr>
                  <td colSpan={6} style={{  borderBottom: '1px solid black', padding: '5px', verticalAlign: 'middle' }}>
                  </td>
                  <td colSpan={6} style={{ borderBottom: '1px solid black', padding: '5px', verticalAlign: 'middle' }}>
                  </td>
                </tr>

                <tr>
                  <td colSpan={8} style={{ borderRight: '1px solid black', borderBottom: '1px solid black', padding: '8px', verticalAlign: 'top', height: '120px' }}>
                    <span style={{ fontSize: '12px' }}>Consignee:</span><br />
                    <b style={{ fontSize: '15px' }}>{plantDetails?.consignee}</b><br />
                    <span style={{ fontSize: '13px' }}>{plantDetails?.country}</span>
                  </td>
                  <td colSpan={12} style={{ borderBottom: '1px solid black', padding: '8px', verticalAlign: 'top' }}>
                    <b style={{ fontSize: '12px' }}>BANK DETAILS:</b><br />
                    <span style={{ fontSize: '13px' }}>
                      {plantDetails?.bankInfo?.[0]?.displayName}<br />
                      Bank name: {plantDetails?.bankInfo?.[0]?.bankName}
                    </span>
                  </td>
                </tr>

               

                <tr>
                  <td colSpan={3} style={{  borderBottom: '1px solid black', textAlign: 'center', padding: '6px', fontWeight: 'bold', fontSize: '11px', width: '15%' }}>MARKS</td>
                  <td colSpan={11} style={{ borderRight: '1px solid black', borderBottom: '1px solid black', textAlign: 'center', padding: '6px', fontWeight: 'bold', fontSize: '11px', width: '55%' }}>DESCRIPTION</td>
                  <td colSpan={2} style={{ borderRight: '1px solid black', borderBottom: '1px solid black', textAlign: 'center', padding: '6px', fontWeight: 'bold', fontSize: '11px' }}>Quantity</td>
                  <td colSpan={2} style={{ borderRight: '1px solid black', borderBottom: '1px solid black', textAlign: 'center', padding: '6px', fontWeight: 'bold', fontSize: '11px' }}>Rate</td>
                  <td colSpan={2} style={{ borderBottom: '1px solid black', textAlign: 'center', padding: '6px', fontWeight: 'bold', fontSize: '11px' }}>Amount</td>
                </tr>

                {(() => { totalLbWeight = 0; totalInvoiceAmount = 0; return null; })()}

                {plantDetails?.gradeInfo?.map((g, gIndex) =>
                  g.info.map((r, idx) => {
                    const uom = UnitsOfWeightInput.find((u: any) => u.value == r.uomId);
                    const uomPrice = UnitsOfWeightInput.find((u: any) => u.value == r.priceUom);

                    let finalNetWeight = 0;
                    let unitPrice = 0;

                    if (conditionRes?.[0]?.quantityUom === true) {
                      finalNetWeight = (uom?.name === UomEnum.LB || uom?.name === UomEnum.OZ)
                        ? Number(r.quatity) : Number(r.quatity) / 0.454;
                      unitPrice = (uomPrice?.name === UomEnum.LB || uomPrice?.name === UomEnum.OZ)
                        ? Number(r.price) : Number(r.price) * 0.454;
                    } else {
                      finalNetWeight = (uom?.name === UomEnum.LB || uom?.name === UomEnum.OZ)
                        ? Number(r.quatity) * 0.454 : Number(r.quatity);
                      unitPrice = (uomPrice?.name === UomEnum.LB || uomPrice?.name === UomEnum.OZ)
                        ? Number(r.price) / 0.454 : Number(r.price);
                    }

                    const rowAmount = Number(unitPrice) * Number(finalNetWeight);

                    totalLbWeight += finalNetWeight;
                    totalInvoiceAmount += rowAmount;

                    return (
                      <tr key={`${gIndex}-${idx}`} className="items-row">
                        <td colSpan={3} style={{ padding: '6px', textAlign: 'center' }}></td>
                        <td colSpan={11} style={{ padding: '6px', textAlign: 'center', borderRight: '1px solid black' }}>
                          <b style={{ fontSize: '13px' }}>{g?.productDescription?.toUpperCase()}</b><br />
                        </td>
                        <td colSpan={2} style={{ padding: '6px', textAlign: 'center', borderRight: '1px solid black' }}>
                          <b style={{ fontSize: '13px' }}>{Number(finalNetWeight).toLocaleString('en-US', { minimumFractionDigits: 1 })}</b>
                        </td>
                        <td colSpan={2} style={{ padding: '6px', textAlign: 'center', borderRight: '1px solid black' }}>
                          <b style={{ fontSize: '13px' }}>{Number(unitPrice).toFixed(2)}</b>
                        </td>
                        <td colSpan={2} style={{ padding: '6px', textAlign: 'center', borderRight: '1px solid black' }}>
                          <b style={{ fontSize: '13px' }}>{rowAmount.toFixed(2)}</b>
                        </td>
                      </tr>
                    );
                  })
                )}

                {renderItemSpacerRows('order-confirmation')}

                <tr>
                  <td colSpan={14} style={{ borderTop: '1px solid black', padding: '8px' }}>
                    <b style={{ fontSize: '12px' }}>Amount Chargeable: &nbsp;&nbsp; {toWords.convert(Number(totalInvoiceAmount), { currency: true }).toUpperCase()} ONLY.</b><br />
                    <span style={{ fontSize: '10px' }}>(In Words)</span>
                  </td>
                  <td colSpan={4} style={{ borderTop: '1px solid black', textAlign: 'right', padding: '8px', fontWeight: 'bold', fontSize: '13px' }}>
                    TOTAL
                  </td>
                  <td colSpan={2} style={{ borderTop: '1px solid black',borderLeft: '1px solid black',borderBottom: '1px solid black', textAlign: 'right', padding: '8px', fontWeight: 'bold', fontSize: '13px' }}>
                    {Number(totalInvoiceAmount).toFixed(2)}
                  </td>
                </tr>

                <tr>
                  <td colSpan={20} style={{  padding: '8px', verticalAlign: 'top' }}>
                    <b style={{ fontSize: '12px' }}>TERMS AND CONDITIONS:</b><br />
                    <b style={{ fontSize: '11px' }}>PAYMENT TERMS: {plantDetails?.saleOrderItems?.[0]?.paymentTerms?.toUpperCase()}</b><br />
                    <b style={{ fontSize: '11px' }}>SHIPMENT: 1) DISPATCH BY {moment(plantDetails?.proformaInvoiceDate).add(15, 'days').format('DD MMMM YYYY')?.toUpperCase()}</b><br />
                    <b style={{ fontSize: '11px' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2) CIF TO {plantDetails?.saleOrderItems?.[0]?.destinationDetails?.toUpperCase()}</b><br />
                    <b style={{ fontSize: '11px' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3) COUNTRY OF ORIGIN - INDIA</b><br />
                    <b style={{ fontSize: '11px' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4) MODE OF SHIPMENT - BY SEA</b><br />
                    <b style={{ fontSize: '11px' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5) QUANTITY 10% +/-</b>
                  </td>
                </tr>

                <tr>
                  <td colSpan={14} style={{ borderTop: '1px solid black', padding: '8px', verticalAlign: 'top' }}>
                    <b style={{ fontSize: '12px' }}>BUYERS SEAL AND SIGNATURE:</b><br />
                    <span style={{ fontSize: '10px', fontWeight: 'bold', width: '50%' }}>

                    </span>
                  </td>

                  <td colSpan={6} style={{ borderLeft: '1px solid black', borderTop: '1px solid black', textAlign: 'center', padding: '8px', verticalAlign: 'top' }}>
                    <b style={{ fontSize: '12px' }}>For S.P.S.A.SILKS PVT. LTD.,</b>
                    <br /><br /><br /><br />
                    <span style={{ fontSize: '11px' }}>Authorised signatory</span>
                  </td>
                </tr>

              </table>

            </body>
          </html>
          : <Card title={<span style={{ color: 'black', borderColor: 'black', borderStyle: 'initial', height: '100' }}>Proforma Invoice</span>}
            style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff' }}><span style={{ paddingTop: '10px', textAlign: 'center' }} ><Spin /></span></Card>}

      </div>
    </Card>
  )
}

export default ProformaInvoice;